import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getIsCustomEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { useBreakpointContext } from 'EmailEditorUI/components/mo/BreakpointContext';
// @ts-expect-error no declarations found for module
import { getEffectiveSectionBackgroundColor } from 'EmailEditorUI/utils/styleUtils';
// @ts-expect-error no declarations found for module
import { getIsBoxedLayout } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { getMobileStyle } from 'EmailEditorUI/utils/breakpointUtils';
import useIsSectionBoxed from 'EmailEditorUI/hooks/styleSettings/useIsSectionBoxed';
import useStyleSetting from 'EmailEditorUI/hooks/styleSettings/useStyleSetting';
export const BREAKPOINT_STYLES = ['backgroundColor', 'backgroundImage', 'backgroundImageType', 'backgroundType', 'paddingBottom', 'paddingTop'];
function useSectionBreakpointStyles(section, {
  breakpointName
} = {}) {
  var _breakpointName;
  const {
    breakpointName: __breakpointNameFromContext
  } = useBreakpointContext();
  (_breakpointName = breakpointName) !== null && _breakpointName !== void 0 ? _breakpointName : breakpointName = __breakpointNameFromContext;
  const [bodyColor] = useStyleSetting('body_color', {
    breakpointName
  });
  const boxedMode = useSelector(getIsBoxedLayout);
  const isCustomEmail = useSelector(getIsCustomEmail);
  const isBoxed = useIsSectionBoxed(section);
  const getBreakpointStyle = useCallback(style => {
    if (!section) {
      return null;
    }
    const defaultStyle = section.getIn(['style', style]);
    const mobileStyle = getMobileStyle(section.get('style'), style);
    if (breakpointName === 'mobile') {
      return mobileStyle !== null && mobileStyle !== void 0 ? mobileStyle : defaultStyle;
    }
    return defaultStyle;
  }, [breakpointName, section]);
  const getBackgroundColor = useCallback(() => {
    const backgroundColor = getBreakpointStyle('backgroundColor');
    if (backgroundColor || !isCustomEmail) {
      return getEffectiveSectionBackgroundColor(isBoxed, boxedMode, backgroundColor, bodyColor);
    }
    return null;
  }, [bodyColor, boxedMode, getBreakpointStyle, isBoxed, isCustomEmail]);
  const getStyle = useCallback(style => {
    if (style === 'backgroundColor') {
      return getBackgroundColor();
    }
    return getBreakpointStyle(style);
  }, [getBackgroundColor, getBreakpointStyle]);
  return useMemo(() => ({
    backgroundColor: getStyle('backgroundColor'),
    backgroundImage: getStyle('backgroundImage'),
    backgroundImageType: getStyle('backgroundImageType'),
    backgroundType: getStyle('backgroundType'),
    paddingBottom: getStyle('paddingBottom'),
    paddingTop: getStyle('paddingTop')
  }), [getStyle]);
}
export default useSectionBreakpointStyles;